import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, XIcon } from "lucide-react";
import { useState } from "react";

import type { INavbarLink } from "./Navbar";
import NavbarSnackbarItem from "./NavbarSnackbarItem";

interface NavbarSnackbarProps {
	links: INavbarLink[];

	darkIcon?: boolean;
}
const NavbarSnackbar = ({ links, darkIcon }: NavbarSnackbarProps) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className="relative mr-2 -ml-0.5 border-r pr-3">
			<button
				className={clsx(
					"flex items-center rounded-full p-1 hover:bg-black/10",
					{
						"text-white": darkIcon,
					},
				)}
				onClick={() => setIsOpen(true)}
			>
				<Menu size={26} />
			</button>

			<AnimatePresence>
				{isOpen && (
					<>
						<motion.div
							initial={{ opacity: 0 }}
							animate={{
								opacity: 1,
								transition: {
									duration: 0.2,
								},
							}}
							exit={{
								opacity: 0,
								transition: {
									duration: 0.2,
								},
							}}
							key="navbar-snackbar-backdrop"
							className="fixed inset-0 z-10 h-screen bg-black/40 dark:bg-black/30"
							onClick={() => setIsOpen(false)}
						/>

						<motion.div
							initial={{ opacity: 0, x: -100 }}
							animate={{
								opacity: 1,
								x: 0,
								transition: {
									duration: 0.2,
								},
							}}
							exit={{
								opacity: 0,
								x: -100,
								transition: {
									duration: 0.1,
								},
							}}
							key="navbar-snackbar"
							className="fixed top-0 left-0 z-30 flex h-screen w-80 flex-col gap-2 overflow-y-auto overflow-x-hidden border bg-white px-4 py-3 shadow-xl dark:bg-slate-800"
						>
							<button
								className="-mr-1 mb-1 self-end rounded-full bg-slate-100 p-1.5 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600"
								onClick={() => setIsOpen(false)}
							>
								<XIcon size={17} strokeWidth={2.4} />
							</button>

							<div className="flex flex-col gap-3">
								{links.map((link) => (
									<NavbarSnackbarItem
										key={link.label}
										link={link}
										toggleSnackbar={() => setIsOpen(!isOpen)}
									/>
								))}
							</div>
						</motion.div>
					</>
				)}
			</AnimatePresence>
		</div>
	);
};

export default NavbarSnackbar;
